import { RefObject, useEffect, useRef } from "react";

export const useOutsideClick = (reference: RefObject<HTMLElement>, callback: () => void, selector?: string) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (reference?.current && (event.target as Node) !== reference?.current && !reference?.current?.contains(event.target as Node)) {
        callback();
      }
    };
    document.addEventListener("mouseup", handleClickOutside);
    document.addEventListener("touchend", handleClickOutside);
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
      document.removeEventListener("touchend", handleClickOutside);
    };
  }, [callback]);

  return ref;
};
